
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wpl-womens-indian-premier-league-2025",
      function () {
        return require("private-next-pages/wpl-womens-indian-premier-league-2025/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wpl-womens-indian-premier-league-2025"])
      });
    }
  